// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dyxV","top":"styles_top__36OyU"};